import { ActionTypes, types } from './user.types'
import UserInterface from '../../interfaces/UserInterface'

export function userProfileReadSuccess(data: UserInterface): ActionTypes {
  return {
    type: types.USER_PROFILE_READ,
    payload: data,
  }
}
